import clsx from 'clsx';
import React from 'react';
import capitalize from '@insurancemenu/imenu-components-lib/dist/helpers/capitalize';
import { EnrollmentStage } from 'types/enrollmentService';
import { createStyles } from './styles';
import { STAGE_TAG } from '../constants';

enum EnrollmentStageTagType {
  RENEWAL = 'Renewal',
  INSTALLED = 'Installed',
  QUOTING = 'Quoting',
  ENROLLING = 'Enrollment',
  NEW_LEAD = 'Lead',
  ARCHIVED = 'Archived',
  INVITED = 'Invited',
  ACTIVE = 'Active',
  SUBMITTED = 'Submitted',
  SOLD = 'Sold',
  DORMANT = 'Dormant',
}

export interface StageTagProps {
  // DORMANT is not an enrollment stage, but it's included here to display its tag for consistency on dashboards.
  stage: EnrollmentStage | 'DORMANT';
}

const StageTag: React.FC<StageTagProps> = ({ stage }) => {
  const classes = createStyles();
  return (
    <div
      data-test-id={STAGE_TAG}
      className={clsx(classes.tag, classes[`tagType${capitalize(EnrollmentStageTagType[stage])}`])}
    >
      {EnrollmentStageTagType[stage]}
    </div>
  );
};

export default StageTag;
